export default __webpack_public_path__ + "static/media/grafema_ummi_06.d31f319a.jpg";